export const OFFLINE_PAYMENT_METHODS = [
    'wire',
    'paySupplier',
    'invoice',
    ''
];
